import styled from 'styled-components';
import BaseSecuritiesModal from '../BaseSecuritiesModal';

export const Modal = styled(BaseSecuritiesModal)`
  & .ant-modal-body {
    padding: 40px;

    & > div,
    & > p {
      margin-bottom: 16px;

      :last-child {
        margin-bottom: 0;
      }
    }
  }

  & .ant-modal-close-x {
    margin-top: 22px;
    margin-right: 20px;
  }
`;

export const InfoWrapper = styled.div`
  & > p {
    margin: 0 0 4px;

    :last-child {
      margin: 0;
    }
  }
`;

export const Text = styled.p<{ weight?: string }>`
  margin: 0;
  font-size: 14px;
  font-weight: ${({ weight = 'normal' }) => weight};
  line-height: 19px;
`;
